// JSON-LD schema helpers — OnSports
// Equivalente CRA di lib/schemas.ts (Next.js spec). Usato da:
//  - public/index.html (Organization + WebSite, inline)
//  - components/NewsArticleLayout.jsx (Article + Breadcrumb, via Helmet)
//  - eventuali pagine Servizio (Service)

export const BASE_URL = "https://www.weareonsports.com";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${BASE_URL}/#organization`,
  name: "OnSports",
  alternateName: "OnSports — Impact Sports Consultancy",
  url: BASE_URL,
  logo: {
    "@type": "ImageObject",
    url: `${BASE_URL}/images/logo.png`,
    width: 512,
    height: 512,
  },
  description:
    "La prima Impact Sports Consultancy in Italia. Strategia, sponsorship, content & IP, performance marketing per brand sportivi e property internazionali.",
  foundingDate: "2018",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Via Jacopo Dal Verme, 7",
    addressLocality: "Milano",
    postalCode: "20159",
    addressRegion: "MI",
    addressCountry: "IT",
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: "hello@weareonsports.com",
    contactType: "customer service",
    areaServed: "IT",
    availableLanguage: ["Italian", "English"],
  },
  sameAs: [
    "https://www.linkedin.com/company/weareonsports/",
    "https://www.instagram.com/weare_onsports/",
    "https://www.facebook.com/weareonsports/",
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${BASE_URL}/#website`,
  url: BASE_URL,
  name: "OnSports",
  publisher: { "@id": `${BASE_URL}/#organization` },
  inLanguage: "it-IT",
};

export function articleSchema(article) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.subtitle,
    datePublished: article.publishedAt,
    dateModified: article.publishedAt,
    author: {
      "@type": article.author.toLowerCase().includes("founder")
        ? "Person"
        : "Organization",
      name: article.author,
    },
    publisher: { "@id": `${BASE_URL}/#organization` },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${BASE_URL}/news/${article.slug}`,
    },
    articleSection: article.rubric,
    keywords: [
      article.rubric,
      article.pillarPrimary,
      ...(article.pillarsSecondary || []),
    ].join(", "),
    inLanguage: "it-IT",
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${BASE_URL}${item.url}`,
    })),
  };
}

export function serviceSchema({ name, description, slug }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    description,
    provider: { "@id": `${BASE_URL}/#organization` },
    areaServed: { "@type": "Country", name: "Italy" },
    url: `${BASE_URL}/servizi/${slug}`,
  };
}
